/*********************** Custom JS for Boost AI Search & Discovery  ************************/

const customize = {
  updateBtns: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Buttons',
      enabled: true,
      apply: () => ({
        afterRender(element){
          let product_id = element.getParams().props.product.id;
          let productItem = document.querySelector('[data-product-id="'+ product_id +'"]');
          productItem.querySelector('.boost-sd__product-title').innerHTML = element.getParams().props.product.title;
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateBtns]);